import { STATUS_NEW } from '../../../config/constants';
import { createBlankStepOne, createBlankStepTwo, createBlankStepThree } from './stepTwoUtils';
import { localDateString } from '../../../utils/localDate';

const ISO_DATE = () => new Date().toISOString();
// Local calendar day (NOT UTC) — see utils/localDate.js for why.
const TODAY = () => localDateString();

export function createJhaSkeleton({
    id = null,
    status = STATUS_NEW,
    createdAt = ISO_DATE(),
    defaultPerson = '',
    docs = [],
    evaluation = [],
    today = TODAY(),
    metaLastStep = 1,
} = {}) {
    return {
        id,
        localId: id,
        status,
        createdAt,
        submittedAt: null,
        stepOne: createBlankStepOne(evaluation, defaultPerson, today),
        stepTwo: createBlankStepTwo(docs),
        stepThree: createBlankStepThree(),
        stepFour: {
            employeesSelected: []
        },
        stepFive: {
            checklist: {},
            checklistNotes: {},
            comments: '',
            supervisorSignature: '',
            completedAt: null
        },
        meta: { lastStep: metaLastStep },
    };
}

export default createJhaSkeleton;